import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'
import { useState } from 'react'
import { app } from './initialise'

export { app }

export const auth = () => getAuth(app())
export const firestore = () => getFirestore(app())
export const functions = () => getFunctions(app())
export const storage = () => getStorage(app())

export const useApp = () => {
  const [isInitialised] = useState(true)
  return { isInitialised }
}